
import {
  defineComponent,
  nextTick,
  onBeforeUpdate,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  toRefs,
  watch
} from 'vue'
import { request } from '@/utils/request'
import { Toast, Image, List, Popup } from 'vant'
import Carousel from '@/components/Carousel.vue'
import SelectCity from '@/components/SelectCity.vue'
import DiglogForm from '@/components/DiglogForm.vue'
import Video from '@/components/Video.vue'
;(Image as any).props.showError.default = false
;(Image as any).props.showLoading.default = false
import { MainData, HouseData, LiveData } from '@/api-types.d.ts'
import ClipboardJS from 'clipboard'
import { useRoute } from 'vue-router'

export class Statistical {
  private isAppend = false
  perform() {
    if (!this.isAppend) {
      this.isAppend = true
      const s = document.createElement('script')
      s.src = '//cdn.leju.com/lejuTj/gather.source.js'
      s.onload = () => document.body.removeChild(s)
      document.body.append(s)
    }
  }
}

const statistical = new Statistical()

const hideVideoTips = (item: Record<string, any>) => {
  if (item.desc) {
    item.desc = ''
  }
}

const injectMapScript = (city: Ref<string>) => {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.src =
    '//api.map.baidu.com/getscript?type=webgl&v=1.0&ak=XIZOl0V1kZbfpzkOu9XofR9rg3BMleqi'
  const res = new Promise<void>(r => {
    s.onload = () => {
      document.body.removeChild(s)
      r()
    }
  })
  document.body.append(s)
  setTimeout(() => {
    if (!window.BMapGL) {
      city.value = window.DEFAULT_CITY || ''
    }
  }, 2000)
  return res
}

let cityField: 'out_city_en' | 'city_en' = 'city_en'
const useLocation = () => {
  const route = useRoute()
  const city = ref((route.query.city as string) || '')
  const visibleCityPopup = ref(false)
  const getCurrent = () => {
    new window.BMapGL.LocalCity().get(({ name }: any) => {
      const ipCity = name === '全国' ? name : name.slice(0, -1)
      cityField = 'city_en'
      city.value = ipCity
      new window.BMapGL.Geolocation().getCurrentPosition((c: any) => {
        if (c) {
          const gpsCity = c.address.city.slice(0, -1)
          if (gpsCity !== ipCity) {
            cityField = 'city_en'
            city.value = gpsCity
          }
        }
      })
    })
  }
  if (city.value) {
    cityField = 'out_city_en'
  } else {
    injectMapScript(city).then(getCurrent)
  }

  return {
    city,
    visibleCityPopup,
    handleSelectCity() {
      cityField = 'out_city_en'
      visibleCityPopup.value = true
    }
  }
}

const getMainData = async (city: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get<MainData.RootObject>(
      `/?site=api&ctl=purchase&act=get_config&${cityField}=${city}`
    )
    if (code == '0') {
      if (data.new_year_brand.length) {
        data.new_year_brand = data.new_year_brand.filter(
          ({ extend_info }) => extend_info && extend_info.length
        )
      }
      if (data.new_year_blessing.length) {
        data.new_year_blessing = data.new_year_blessing.filter(
          ({ video }) => !!video
        )
      }
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const getLiveData = async (city: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get<LiveData.RootObject>(
      '/?site=api&ctl=purchase&act=get_video&out_city_en=' + city
    )
    if (code == '0') {
      return data.hongpan
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const useHouseData = (city?: string) => {
  const loading = ref(false)
  const finished = ref(true)
  let p = 1
  return {
    loading,
    finished,
    load: async (houseData: HouseData.Data[], reload = false) => {
      if (!city) return
      if (loading.value) return
      loading.value = true
      if (reload) p = 1
      try {
        const {
          data: {
            code,
            entry: { data, count }
          }
        } = await request.get<HouseData.RootObject>(
          '/?site=api&ctl=purchase&act=get_worth_buy&out_city_en=' +
            city +
            '&p=' +
            p++
        )
        finished.value = (p - 1) * 5 >= count
        loading.value = false
        if (code == 0) {
          if (reload) {
            houseData.splice(0, houseData.length, ...data)
          } else {
            houseData.push(...data)
          }
        } else {
          Toast.fail('获取数据失败')
        }
      } catch {
        loading.value = false
        Toast.fail('获取数据失败')
      }
    }
  }
}

const useLetterData = (visibleFormPopup: Ref<boolean>) => {
  const res = reactive({
    letterData: {
      showPopup: false,
      scrolling: false,
      showFloat: false,
      openForm() {
        visibleFormPopup.value = true
        res.letterData.showFloat = true
        res.letterData.showPopup = false
      }
    }
  })
  let timer = 0
  const onScroll = () => {
    if (!res.letterData.scrolling) {
      res.letterData.scrolling = true
    }
    clearTimeout(timer)
    timer = setTimeout(() => {
      res.letterData.scrolling = false
    }, 500)
  }
  onMounted(() => {
    window.addEventListener('scroll', onScroll)
  })
  onUnmounted(() => {
    clearTimeout(timer)
    window.removeEventListener('scroll', onScroll)
  })
  setTimeout(() => {
    res.letterData.showPopup = true
  }, 3000)
  return toRefs(res)
}

const getData = (city: Ref<string>) => {
  const res: {
    mainData: MainData.Data | Record<string, never>
    liveData: LiveData.Data['hongpan'] | Record<string, never>
    houseData: HouseData.Data[]
    houseState: ReturnType<typeof useHouseData> | null
  } = reactive({
    mainData: {},
    liveData: [],
    houseData: [],
    houseState: null
  })
  onMounted(() => {
    watch(
      city,
      async v => {
        if (v) {
          if (v === res.mainData?.city_map) return
          {
            const data = await getMainData(v)
            if (data) {
              res.mainData = data
              data.city_map && (v = city.value = data.city_map)
              data.city_pinyin && (window.city = data.city_pinyin)
              window.news_source = 'index'
              // statistical.perform()
              {
                const data = await getLiveData(v)
                if (data) {
                  res.liveData = data
                }
              }
              {
                res.houseState = useHouseData(v)
                res.houseState.load(res.houseData, true)
              }
            }
          }
        }
      },
      {
        immediate: true
      }
    )
  })
  return {
    ...toRefs(res)
  }
}

const useTaoling = () => {
  const showTaoPopup = ref(false)
  const copyElementRef = ref<HTMLDivElement | null>(null)
  const taoling = ref('')
  onMounted(() => {
    copyElementRef.value &&
      new ClipboardJS(copyElementRef.value).on('success', function (e) {
        e.clearSelection()
      })
  })
  const copyTaoling = (ling: string) => {
    taoling.value = ling
    nextTick(() => {
      copyElementRef.value?.click()
      showTaoPopup.value = true
    })
  }
  return {
    showTaoPopup,
    copyElementRef,
    taoling,
    copyTaoling
  }
}
const setBgc = () => {
  onMounted(() => {
    document.body.style.backgroundColor = '#d40218'
  })
  onUnmounted(() => {
    document.body.style.backgroundColor = 'inherit'
  })
}

export default defineComponent({
  name: 'Home',
  components: {
    Video,
    DiglogForm,
    Image,
    Carousel,
    List,
    Popup,
    SelectCity
  },
  setup() {
    const playerRefs = ref<any[]>([])
    onBeforeUpdate(() => {
      playerRefs.value = []
    })
    const { city, visibleCityPopup, handleSelectCity } = useLocation()
    setBgc()
    const visibleFormPopup = ref(false)
    return {
      playerRefs,
      city,
      visibleCityPopup,
      visibleFormPopup,
      handleSelectCity,
      SHOW_TAO: Number(useRoute().query.hide_tao) !== 1,
      ACTIVITY_ENTRY: window.ACTIVITY_ENTRY || '',
      jump(
        res:
          | { type: 'link'; data: string }
          | { type: 'tab'; data: 'home' | 'hot' }
          | { type: 'house'; data: HouseData.Data }
      ) {
        if (res.type === 'link') {
          window.location.href = res.data
        } else if (res.type === 'house') {
          window.location.href = `//m.leju.com/touch/house/${res.data.city_en}/${res.data.hid}?oc_source=m_zhuanti_fanxiang`
        } else if (res.type === 'tab') {
          if (res.data === 'home' && window.HOME_LINK) {
            window.location.href = window.HOME_LINK
          } else if (res.data === 'hot' && window.HOT_LINK) {
            window.location.href = window.HOT_LINK
          }
        }
      },
      hideVideoTips,
      ...getData(city as Ref<string>),
      ...useTaoling(),
      ...useLetterData(visibleFormPopup)
    }
  }
})
